import { Grids } from 'types';

// Maximum number of characters to display in the change grid to prevent performance issues
export const MAX_CHANGE_GRID_CHARACTERS = 300;

const cellAt = (grid: string[], index: number): string => grid[index] ?? '';

// \u0001 is CTF padding and should not be highlighted. Empty cells (API padding or a missing
// counterpart when the two grids have different lengths) have charCode NaN, which is not 1,
// so they still highlight as a real insertion/deletion.
const isHighlightable = (char: string): boolean => char.charCodeAt(0) !== 1;

export const buildDifferenceGrids = (masterGrid: string[], sampleGrid: string[]): Grids => {
  const grids: Grids = {
    masterGrid: [],
    sampleGrid: [],
  };

  const maxLength = Math.min(Math.max(masterGrid.length, sampleGrid.length), MAX_CHANGE_GRID_CHARACTERS);

  for (let i = 0; i < maxLength; i++) {
    const masterChar = cellAt(masterGrid, i);
    const sampleChar = cellAt(sampleGrid, i);
    const diff = masterChar !== sampleChar;
    grids.masterGrid.push({ index: i, character: masterChar, diff: isHighlightable(masterChar) && diff });
    grids.sampleGrid.push({ index: i, character: sampleChar, diff: isHighlightable(sampleChar) && diff });
  }

  return grids;
};
